var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeIcon = function SvgEyeIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41315 5.63301C5.25406 5.63301 3.26165 7.05322 1.90992 8.34718C1.15867 9.06632 1.15867 10.333 1.90992 11.0522C3.26166 12.3461 5.25406 13.7663 7.41315 13.7663C9.57224 13.7663 11.5646 12.3461 12.9164 11.0522C13.6676 10.333 13.6676 9.06632 12.9164 8.34718C11.5646 7.05322 9.57224 5.63301 7.41315 5.63301ZM1.08012 7.48033C2.48013 6.14015 4.76664 4.43301 7.41315 4.43301C10.0597 4.43301 12.3462 6.14015 13.7462 7.48033C14.991 8.67197 14.991 10.7274 13.7462 11.919C12.3462 13.2592 10.0597 14.9663 7.41315 14.9663C4.76664 14.9663 2.48013 13.2592 1.08012 11.919C-0.164727 10.7274 -0.164728 8.67197 1.08012 7.48033Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4125 8.66328C6.83994 8.66328 6.37578 9.12744 6.37578 9.7C6.37578 10.2726 6.83994 10.7367 7.4125 10.7367C7.98506 10.7367 8.44922 10.2726 8.44922 9.7C8.44922 9.12744 7.98506 8.66328 7.4125 8.66328ZM5.17578 9.7C5.17578 8.46469 6.17719 7.46328 7.4125 7.46328C8.64781 7.46328 9.64922 8.46469 9.64922 9.7C9.64922 10.9353 8.64781 11.9367 7.4125 11.9367C6.17719 11.9367 5.17578 10.9353 5.17578 9.7Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41406 0.0996094C7.74543 0.0996094 8.01406 0.368239 8.01406 0.699609V2.19961C8.01406 2.53098 7.74543 2.79961 7.41406 2.79961C7.08269 2.79961 6.81406 2.53098 6.81406 2.19961V0.699609C6.81406 0.368239 7.08269 0.0996094 7.41406 0.0996094Z",
    fill: "#595959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8383 2.27535C14.0726 2.50966 14.0726 2.88956 13.8383 3.12387L12.8383 4.12387C12.604 4.35819 12.2241 4.35819 11.9898 4.12387C11.7555 3.88956 11.7555 3.50966 11.9898 3.27535L12.9898 2.27535C13.2241 2.04103 13.604 2.04103 13.8383 2.27535Z",
    fill: "#595959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.989798 2.27535C0.755484 2.50966 0.755484 2.88956 0.989798 3.12387L1.9898 4.12387C2.22411 4.35819 2.60401 4.35819 2.83833 4.12387C3.07264 3.88956 3.07264 3.50966 2.83833 3.27535L1.83833 2.27535C1.60401 2.04103 1.22411 2.04103 0.989798 2.27535Z",
    fill: "#595959"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "eye-icon.a6d99b5199f9531e1eb13ac853e4e66f.svg";